import { useLocation, useNavigate } from 'react-router-dom';
import { IBillingManagement } from '../../../types/billing-management.type';
import { useManagementBilling } from '../components/customHook/useManagementBilling';
import { getStatusLabels } from '../components/TableBillingManagement';
import Loading from '@/common/components/ui/loading/Loading';
import { useState } from 'react';
import ButtonWithLoader from '@/common/components/ui/loading/ButtonLoading';
import { useToastContext } from '@/common/components/ui/toast/toast.context';
import { adjustSubscription } from '@/common/services/payments.api';
import InfoItem from '@/common/components/ui/form/infoItem';

export default function ManagementBillingDash() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const { notifySuccess, notifyError } = useToastContext();
  const payment: IBillingManagement | undefined = state?.payment;

  const {
    paymentDetails,
    subscriptionId,
    percentualValue,
    partner,
    partnerWallet,
    isLoading,
    error,
    paymentSplitWalletId
  } = useManagementBilling(payment);

  if (!payment) {
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold text-red-600">Nenhum dado de pagamento encontrado</h1>
        <p>Volte para a página anterior e selecione uma fatura.</p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="p-4">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold text-red-600">Erro ao carregar dados</h1>
        <p>{error}</p>
      </div>
    );
  }


  const handleAdjustedSubscription = async () => {
    const paymentData = {
      paymentId: payment.paymentId,
      subscriptionId: subscriptionId,
      correctWalletId: partner?.walletId,
      percentualValue: percentualValue,
      partnerCompany: payment.partnerCompany,

    };
    try {
      setIsLoadingButton(true);
      // Aqui você deve chamar a função que ajusta a assinatura
      const response = await adjustSubscription(paymentData.paymentId, paymentData);

      if (response.ok) {
        notifySuccess("Assinatura ajustada com sucesso!");
      } else {
        notifyError("Erro ao ajustar assinatura: " + response.message as string);
      }
    } catch (error) {
      console.error("Erro ao ajustar assinatura:", error);
      notifyError("Erro ao ajustar assinatura.");
    } finally {
      setIsLoadingButton(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-4 mt-4 bg-white rounded-lg shadow-lg border border-gray-100">
      <div className="border-b pb-2 mb-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl md:text-3xl font-bold text-black">
            Detalhes da Fatura
          </h1>
          <span className={`px-4 py-2 rounded-full text-base font-semibold ${payment.splitDone === false
            ? 'bg-red-100 text-red-800 animate-pulse'
            : 'bg-blue-100 text-blue-800'
            }`}>
            {getStatusLabels(payment.status)}
          </span>
        </div>
        <div className="mt-1">
          <span>
            <a
              href={`https://asaas.com/payment/show/${payment.invoiceNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`hover:underline transition-colors ${payment.splitDone === false
                ? 'text-red-600 hover:text-red-800'
                : 'text-blue-800 hover:text-blue-600'
                }`}
            >
              #{payment.invoiceNumber}
            </a>
          </span>
          <div>
            <h2 className="text-lg  mb-1 border-b "></h2>
            <div className="space-y-3 mb-1 border-b ">
              <InfoItem label="Descrição:" value={paymentDetails?.description} />
              <InfoItem label="Valor do percentual:" value={percentualValue} />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="bg-gray-50 p-2 rounded-lg border bg-gray-50 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-700 mb-3 border-b pb-2">Detalhes da Fatura</h2>
          <div className="space-y-3">
            <InfoItem label="Proprietário do veículo:" value={payment.partnerCompany} />
            <InfoItem label="Carteira do proprietário:" value={partner?.walletId} />
            <InfoItem label="Placa do veículo:" value={payment.licensePlate} />
            <InfoItem label="Carteira de recebimento do split:" value={payment.splitWalletId} />
          </div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg border bg-gray-50 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-700 mb-3 border-b pb-2">Informações de Distribuição Financeira</h2>
          <div className="space-y-3">
            <InfoItem label="Parceiro que recebeu o split:" value={partnerWallet?.companyName} />
            <InfoItem label="Carteira de Destino:" value={paymentSplitWalletId} />
          </div>
        </div>
      </div>

      {/* Ações (se necessário) */}
      <div className="flex justify-between space-x-3 mt-4 border-t pt-2">
        <button
          onClick={() => navigate(-1)}
          className="bg-gray5 rounded-lg hover:bg-gray transition">
          Voltar
        </button>
        {(payment.splitDone === false) && (
          <ButtonWithLoader
            type='button'
            isLoading={isLoadingButton}
            onClick={handleAdjustedSubscription}
          >
            Corrigir
          </ButtonWithLoader>
          // <button className="px-4 py-2 bg-redPrimary text-white rounded hover:bg-red-300 transition">
          //   Corrigir
          // </button>
        )}
      </div>
    </div>
  );
}